import { legalComponent } from './legal.component';
export const legalStateName = 'app.legal';

export const legalState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/legal/:document',
    name: legalStateName,
    params: { document: null },
    component: legalComponent.name,
  });
};



// WEBPACK FOOTER //
// ./src/app/components/legal/legal.state.js